import { useQueryClient } from "@tanstack/react-query";

import { ErrorPage } from "@/components/Pages/Status";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import { notify } from "@/stores/notification.store";
import { useServiceStatusStore } from "@/stores/serviceStatus.store";

/**
 * Covers the app while the browser is offline or the API is down. The page
 * underneath stays mounted, so unsaved form input survives the outage.
 */
export function AppStatusOverlay() {
  const queryClient = useQueryClient();
  const isOnline = useOnlineStatus();
  const isUnavailable = useServiceStatusStore((state) => state.isUnavailable);
  const setUnavailable = useServiceStatusStore((state) => state.setUnavailable);

  // Clearing the flag first lets a still-failing refetch raise it again.
  const retryService = () => {
    setUnavailable(false);
    void queryClient.refetchQueries({ type: "active" });
  };

  // Reloading while offline would land on the browser's own error page; the
  // overlay closes by itself on the "online" event, so retry only reassures.
  const retryConnection = () => notify("هنوز اتصال اینترنت برقرار نشده است", "warning");

  if (!isOnline) return <ErrorPage variant="offline" overlay onRetry={retryConnection} />;
  if (isUnavailable) return <ErrorPage variant="503" overlay onRetry={retryService} />;
  return null;
}
